import { render, staticRenderFns } from "./InputSesshuVaccineMaker.vue?vue&type=template&id=83f6a0e8&"
import script from "./InputSesshuVaccineMaker.vue?vue&type=script&lang=js&"
export * from "./InputSesshuVaccineMaker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports